import { render, staticRenderFns } from "./class_list.vue?vue&type=template&id=257931ba&scoped=true&"
import script from "./class_list.vue?vue&type=script&lang=js&"
export * from "./class_list.vue?vue&type=script&lang=js&"
import style0 from "./class_list.vue?vue&type=style&index=0&id=257931ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257931ba",
  null
  
)

export default component.exports